import { API } from "@/lib/api";
import { ApiError, APIService, FetchListRequestParams } from "@/services/api";
import {
  CalculateContractorsPlannedHoursWizardRequest,
  ReadContractorsPlannedHoursWizardAllocation,
  ReadContractorsPlannedHoursWizardResult,
} from "@/types/contractorsPlannedHoursWizard";

const contractorsPlannedHoursWizardService =
  new APIService<ReadContractorsPlannedHoursWizardAllocation>(
    API.ContractorsPlannedHoursWizard,
  );

/** Cloud returns a JSON array; `APIService.post` expects `{ data }` — normalize both. */
function parseCalculateWizardResponse(
  json: unknown,
): ReadContractorsPlannedHoursWizardResult[] {
  if (Array.isArray(json)) {
    return json as ReadContractorsPlannedHoursWizardResult[];
  }
  if (
    json &&
    typeof json === "object" &&
    "data" in json &&
    Array.isArray((json as { data: unknown }).data)
  ) {
    return (json as { data: ReadContractorsPlannedHoursWizardResult[] }).data;
  }
  return [];
}

export const ContractorsPlannedHoursWizardService = {
  getList: (
    fetchParams: FetchListRequestParams<ReadContractorsPlannedHoursWizardAllocation>,
  ) => contractorsPlannedHoursWizardService.getList(fetchParams),
  calculate: async (
    data: CalculateContractorsPlannedHoursWizardRequest,
  ): Promise<ReadContractorsPlannedHoursWizardResult[]> => {
    const service = contractorsPlannedHoursWizardService;
    const response = await service.performFetch(service.path, "POST", data);
    await service.handleResponseError(response);
    let json: unknown;
    try {
      json = await response.json();
    } catch {
      throw new ApiError("Invalid JSON response", response.status);
    }
    return parseCalculateWizardResponse(json);
  },
};
